import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/tagsNotes',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TagsNotesContainer',
      './modules/tagsNotes'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TagsNotesContainer = require('./containers/TagsNotesContainer').default
      const actions = require('./modules/tagsNotes')
      const reducer = require('./modules/tagsNotes').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'tagsNotes', reducer: reducer })

      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, TagsNotesContainer)

    /* Webpack named bundle   */
    }, 'tagsNotes')
  }
})



// WEBPACK FOOTER //
// ./src/routes/TagsNotesLimitations/index.js